module.exports = __webpack_public_path__ + "img/icon2.c52d9290.png";